import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/builds/connection-ticketing/boats-spa/web-app/layouts/checkout.vue")),
  default: defineAsyncComponent(() => import("/builds/connection-ticketing/boats-spa/web-app/layouts/default.vue")),
  empty: defineAsyncComponent(() => import("/builds/connection-ticketing/boats-spa/web-app/layouts/empty.vue"))
}